import { Pipe, PipeTransform } from '@angular/core';

import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsFilterUtil } from '../core/utils/filter-util';

@Pipe({
  name: 'rdsFilterTypeSubtitle',
})
export class FilterTypeSubtitlePipe implements PipeTransform {
  transform(variable: Variable | VariableSummary): string {
    const type = RdsFilterUtil.determineType(variable);
    // Title case the type and add the text ' Filter',
    // i.e. where type is CODE, it would be transformed to
    // 'Code Filter'
    return !type ? '' : `${type[0].toUpperCase()}${type.substr(1).toLowerCase()} Filter`;
  }
}
